<template>
  <div class="col">
    <table class="table table-bordered" aria-label="table-pdf">
      <thead>
        <tr>
          <th scope="col" class="text-center">
            Copropriétaire
          </th>
          <th scope="col" class="text-center">
            Lots
          </th>
          <th
            v-for="votingCategory in votingCategoriesForTable"
            :key="'vc-1-' + votingCategory.id"
            scope="col"
            class="text-center"
          >
            {{ votingCategory.name.toUpperCase() }}
          </th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="bo in sortedBuildingOwners" :key="bo.id">
          <th scope="row">
            <div>
              <div class="d-flex flex-column align-items-center">
                <div class="font-weight-bold">
                  {{
                    getPersonGender({ personId: bo.id }) + " " + getPersonName({ personId: bo.id })
                  }}
                </div>
                <div class="font-weight-normal font-italic">
                  {{ getPersonAddress({ personId: bo.id }) }}
                </div>
                <div class="font-weight-normal font-italic">
                  {{ getPersonComplements({ personId: bo.id }) }}
                </div>
                <div class="font-weight-normal font-italic">
                  {{ getPersonComplements({ personId: bo.id }, undefined, 2) }}
                </div>
                <div class="font-weight-normal font-italic">
                  {{ getPersonZipcodeAndCity({ personId: bo.id }) }}
                </div>
              </div>
            </div>
          </th>
          <th scope="row">
            <div
              v-for="buildingLot in bo.building_lots"
              :key="'b-lot-1-' + buildingLot.id"
              class="d-flex flex-column align-items-center mt-1"
            >
              <div>{{ buildingLot.name }}</div>
            </div>
          </th>
          <th
            v-for="votingCategory in votingCategoriesForTable"
            :key="'vc-2-' + votingCategory.id"
            scope="row"
          >
            <div>
              <div
                v-for="buildingLot in bo.building_lots"
                :key="'b-lot-2-' + buildingLot.id"
                class="d-flex flex-column align-items-center mt-1"
              >
                <div>
                  {{
                    getTotalBOTantiemesByVotingCategoryAndBuildingLot(
                      bo.id,
                      votingCategory.id,
                      buildingLot.id
                    )
                  }}
                </div>
              </div>
              <div class="d-flex flex-column align-items-center mt-2">
                {{ "Total " + getTotalBOTantiemesByVotingCategory(bo.id, votingCategory.id) }}
              </div>
            </div>
          </th>
        </tr>
        <tr>
          <th scope="row" class="text-center" colspan="2">
            <span>Total tantièmes</span>
          </th>
          <th
            v-for="votingCategory in votingCategoriesForTable"
            :key="'vc-3-' + votingCategory.id"
            class="text-center font-weight-normal"
            scope="row"
          >
            <span>{{ getTotalTantiemesByVotingCategory(votingCategory.id) }}</span>
          </th>
        </tr>
      </tbody>
    </table>
  </div>
</template>
<script>
export default {
  props: ["sortedBuildingOwners", "votingCategories"],
  data() {
    return {
      headerClass: "text-center align-middle",
      fields: [
        {
          key: "name",
          label: "Copropriétaire",
          thClass: "text-center align-middle",
        },
        {
          key: "lots",
          label: "Lots",
          thClass: "text-center align-middle",
        },
      ],
      isBusy: false,
      votingCategoriesForTable: [],
    };
  },
  created() {
    this.setVotingCategoriesColumns();
  },
  methods: {
    setVotingCategoriesColumns() {
      for (const votingCategoryId of this.votingCategories) {
        const index = this.meetingDetails.VotingCategoriesData.findIndex(
          item => item.id == votingCategoryId
        );
        if (index !== -1) {
          const vc = this.meetingDetails.VotingCategoriesData[index];
          this.votingCategoriesForTable.push(vc);
        }
      }
    },
  },
};
</script>
